import { Control, ControllerProps, FieldValues, Path } from "react-hook-form";
import { AutocompleteProps } from "@mui/material/Autocomplete";
import { TextFieldProps } from "@mui/material/TextField";

import FormAutocomplete, {
  Option,
} from "../../../../components/reusable-components/form/FormAutocomplete";

import { SettingValueType } from "../../models/enums/SettingValueType";
import { SETTING_VALUE_TYPE_OPTIONS } from "../../models/enums/SettingValueTypeOptions";

interface Props<T extends FieldValues = FieldValues> {
  name: Path<T>;
  control: Control<T>;
  disabled?: boolean;
  controllerProps?: Partial<Omit<ControllerProps<T, Path<T>>, "render">>;
  autocompleteProps?: Partial<
    AutocompleteProps<Option<SettingValueType>, false, false, false>
  >;
  textFieldProps?: TextFieldProps;
}

const SettingTypeSelectForm = <T extends FieldValues = FieldValues>({
  name,
  control,
  disabled = false,
  controllerProps,
  autocompleteProps,
  textFieldProps,
}: Props<T>) => {
  const options: Option<SettingValueType>[] = SETTING_VALUE_TYPE_OPTIONS;

  return (
    <FormAutocomplete<T, Path<T>>
      controllerProps={{
        name,
        control,
        ...controllerProps,
      }}
      autocompleteProps={{
        options,
        disabled,
        ...autocompleteProps,
      }}
      textFieldProps={{
        label: "Value Type",
        placeholder: "Select type...",
        ...textFieldProps,
      }}
    />
  );
};

export default SettingTypeSelectForm;
